import { render, staticRenderFns } from "./ProductNew.vue?vue&type=template&id=3ede8891&scoped=true&"
import script from "./ProductNew.vue?vue&type=script&lang=ts&"
export * from "./ProductNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ede8891",
  null
  
)

export default component.exports